import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { IAppConfig } from '../../store';
import { APP_CONFIG } from '../config';
import { TargetSystemDao } from '../daos/target-system.dao';
import { TargetSystemModel } from '../model';
import { LogService } from './logging.service';

const CLASS_NAME = 'TargetSystemService';

@Injectable()
export class TargetSystemService {
  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private _log: LogService,
    private _targetSystemDao: TargetSystemDao
  ) { }

  getTargetSystem(): Observable<TargetSystemModel> {
    return this._targetSystemDao.get()
      .pipe(
        map(({isGigyaSwitchOn}) => {
          const response = new TargetSystemModel(
            !!isGigyaSwitchOn
          );
          this._log.info('Returning resolved value', CLASS_NAME, response);
          return response;
        }),
        catchError(() => {
          this._log.warn(`[ ${CLASS_NAME} ] System Target Api Failed`);
          const response = new TargetSystemModel(
            this.appConfig.simplifiedLoginEnabled
          );
          this._log.info('Returning resolved value', CLASS_NAME, response);
          return Observable.of(response);
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/target-system.service.ts